import React, { useMemo } from 'react'
import SWRCacheViewer from 'protocol-setup/components/SWRCacheViewer';
import useIsCTSUUser from 'protocol-setup/helpers/useIsCTSUUser';
import { useSetupPermission } from 'protocol-setup/helpers';
import ProtectionElements from 'protocol-setup/helpers/ProtectionElement';
import { cloneDeep } from 'lodash';
import { useFetchRequestBrowserData, useLeadGroupLOVs } from 'protocol-setup/redux/useLovs';
import text from 'protocol-setup/constants/text';
import RequestBrowser from './RequestBrowser'
import { requestStatusOptions } from './lov';



export function getLeadGroupLovFromMeta(meta) {

  return cloneDeep(meta.find(x => x.name === 'leadGrp').options);
}


const RequestBrowserWithFormattedData = ({ rows, leadGroupLov, hasAddSetupPermission }) => {
  const formattedRows = useMemo(() => {
    return rows.map(row => {
      const statusOption = requestStatusOptions.find(option => option.value === row.requestStatus);
      return {
        ...row,
        requestStatusFormatted: statusOption ? statusOption.label : row.requestStatus
      };
    });
  }, [rows]);

  return (
    <RequestBrowser 
      rows={formattedRows} 
      leadGroupLov={leadGroupLov} 
      hasAddSetupPermission={hasAddSetupPermission} 
    />
  );
}


function ProtocolSetup() {
  const { requestBrowserData, isLoading } = useFetchRequestBrowserData();
  const { leadGroupList, isLoading: isLoadingAllLeadGroups } = useLeadGroupLOVs();
  const isCTSUUser = useIsCTSUUser();
  const hasAddSetupPermission = useSetupPermission(ProtectionElements.BROWSER_ADD);

  
  if (isLoading || isLoadingAllLeadGroups) {
    return <div>{text.browser.loading}</div>;
  }
  const leadGroupLovFromMeta = getLeadGroupLovFromMeta(requestBrowserData?.meta);
  return (
    <div className='card-wrapper MuiPaper-elevation1 p-4 rounded'>
      <SWRCacheViewer />
      <RequestBrowserWithFormattedData 
        rows={requestBrowserData?.data || []} 
        leadGroupLov={isCTSUUser ? leadGroupList : leadGroupLovFromMeta} 
        hasAddSetupPermission={hasAddSetupPermission}
      />
    </div>
  )
}

export default ProtocolSetup
